import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-telecaller-details',
  templateUrl: './telecaller-details.component.html',
  styleUrls: ['./telecaller-details.component.css']
})
export class TelecallerDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/prospect/telecaller-details/telecaller-details.component.ts